import { render } from "./Clients.vue?vue&type=template&id=53aeda8e&ts=true"
import script from "./Clients.vue?vue&type=script&lang=ts"
export * from "./Clients.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__